/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';

/**
 * IE11 requires the following for NgClass support on SVG elements
 */
// import 'classlist.js';  // Run `npm install --save classlist.js`.

/**
 * Web Animations `@angular/platform-browser/animations`
 * Only required if AnimationBuilder is used within the application and using IE/Edge or Safari.
 * Standard animation support in Angular DOES NOT require any polyfills (as of Angular 6.0).
 */
// import 'web-animations-js';  // Run `npm install --save web-animations-js`.

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 */

// (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
// (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
// (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames

/*
 * in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 * with the following flag, it will bypass `zone.js` patch for IE/Edge
 */
// (window as any).__Zone_enable_cross_context_check = true;

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js';  // Included with Angular CLI.

/**
 * Application imports
 */
// Core ES features
import 'core-js/es/array';
import 'core-js/es/object';
import 'core-js/es/string';
import 'core-js/es/symbol';
import 'core-js/es/set';
import 'core-js/es/map';

// Additional polyfills for older browsers
import 'core-js/es/promise';
import 'core-js/es/reflect';
// Removed problematic import: import 'core-js/proposals/reflect-metadata';
import 'core-js/es/function';
import 'core-js/es/parse-int';
import 'core-js/es/parse-float';
import 'core-js/es/number';
import 'core-js/es/math';
import 'core-js/es/date';
import 'core-js/es/regexp';

// ES2017+ features that might cause issues in older Safari
import 'core-js/es/object/entries';
import 'core-js/es/object/values';
import 'core-js/es/array/includes';
import 'core-js/es/string/pad-start';
import 'core-js/es/string/pad-end';

// Safari specific polyfills
(window as any).__Zone_enable_cross_context_check = true;